import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { OrganizationEntity } from '../../qourses-api-client'

export const organizationStore = create<
  OrganizationEntity & {
    storageLastUpdated: Date
    updateActiveOrganization: (organization: OrganizationEntity) => void
  }
>()(
  persist(
    (set) => ({
      id: '',
      name: '',
      companyLegalName: '',
      description: '',
      slug: '',
      createdAt: '',
      updatedAt: '',
      activeCustomer: null as never,
      storageLastUpdated: new Date(),
      highlightedTag1Id: '',
      highlightedTag2Id: '',
      highlightedTag3Id: '',
      testMode: false,
      archived: false,
      plan: null as never,
      planInterval: null as never,
      planPastDue: false,
      planPaymentFailed: false,
      stripeCustomerId: '',
      trialAvailable: false,
      trialUntilOverride: null as never,
      ignorePlanLimits: null as never,
      logoMediaImageId: '',
      updateActiveOrganization: (organization: OrganizationEntity) =>
        set({
          //check if the new active tenant is empty
          id: organization.id,
          name: organization.name,
          companyLegalName: organization.companyLegalName,
          slug: organization.slug,
          description: organization.description,
          createdAt: organization.createdAt,
          updatedAt: organization.updatedAt,
          activeCustomer: organization.activeCustomer,
          storageLastUpdated: new Date(),
          highlightedTag1Id: organization.highlightedTag1Id,
          highlightedTag2Id: organization.highlightedTag2Id,
          highlightedTag3Id: organization.highlightedTag3Id,
          testMode: organization.testMode,
          archived: organization.archived,
          plan: organization.plan,
          planInterval: organization.planInterval,
          planPastDue: organization.planPastDue,
          planPaymentFailed: organization.planPaymentFailed,
          stripeCustomerId: organization.stripeCustomerId,
          trialAvailable: organization.trialAvailable,
          trialUntilOverride: organization.trialUntilOverride,
          ignorePlanLimits: organization.ignorePlanLimits,
          logoMediaImageId: organization.logoMediaImageId,
        }),
    }),
    {
      name: 'organization-storage',
    },
  ),
)
